"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _react = _interopRequireWildcard(require("react"));

require("./thread.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ToolbarButton extends _react.Component {
  constructor() {
    super(...arguments);

    this.renderIcon = () => {
      const {
        type,
        action,
        animation
      } = this.props;

      switch (type) {
        case 'add':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "primary",
            onClick: e => {
              e.stopPropagation();
              action();
            },
            className: "toolbar-button"
          }, /*#__PURE__*/_react.default.createElement("i", {
            className: `toolbar-button-icon far fa-plus ${animation}`
          }), ' ', "Compose");

        case 'refresh':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "primary",
            onClick: e => {
              e.stopPropagation();
              action();
            },
            className: "toolbar-button"
          }, /*#__PURE__*/_react.default.createElement("i", {
            className: `toolbar-button-icon fas fa-sync-alt ${animation}`
          }), ' ', "Refresh");

        default:
          return /*#__PURE__*/_react.default.createElement("div", null);
      }
    };
  }

  render() {
    return this.renderIcon();
  }

}

var _default = ToolbarButton;
exports.default = _default;